import { useState, useCallback, memo } from 'react';
import { LuSearch } from 'react-icons/lu';
import { parseGridReference } from '../utils/utmGrid';
import {
	GridSearchWrapper,
	GridSearchInput,
	GridSearchButton,
	GridSearchError,
} from './FlightPlannerStyles';

/**
 * Search input for navigating to a UTM/MGRS grid reference.
 * Accepts internal labels, UTM coordinates, and MGRS strings.
 */
const GridReferenceSearch = ({ onNavigate }) => {
	const [query, setQuery] = useState('');
	const [error, setError] = useState('');

	const handleSearch = useCallback(() => {
		setError('');
		const result = parseGridReference(query);
		if (result) {
			onNavigate(result);
		} else {
			setError('Invalid format. Use: 32/500E/6600N, 32V 661965 7266000, or 32VNM6196528316');
		}
	}, [query, onNavigate]);

	const handleKeyDown = useCallback(
		e => {
			if (e.key === 'Enter') handleSearch();
		},
		[handleSearch]
	);

	return (
		<div>
			<GridSearchWrapper>
				<GridSearchInput
					type="search"
					placeholder="e.g. 32V NM 61965 28316"
					value={query}
					onChange={e => setQuery(e.target.value)}
					onKeyDown={handleKeyDown}
				/>
				<GridSearchButton onClick={handleSearch} aria-label="Search grid reference">
					<LuSearch size={16} />
				</GridSearchButton>
			</GridSearchWrapper>
			{error && <GridSearchError>{error}</GridSearchError>}
		</div>
	);
};

export default memo(GridReferenceSearch);
